import { render, staticRenderFns } from "./LevelProgressDetail.vue?vue&type=template&id=18bbb203&scoped=true"
import script from "./LevelProgressDetail.js?vue&type=script&lang=js&external"
export * from "./LevelProgressDetail.js?vue&type=script&lang=js&external"
import style0 from "./LevelProgressDetail.vue?vue&type=style&index=0&id=18bbb203&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18bbb203",
  null
  
)

export default component.exports